(function () {
  'use strict';

  // ─── LIMPIAR DESCUENTO DE COMBO AL CARGAR PÁGINA DE PRODUCTO ─────────────
  // Se ejecuta inmediatamente, antes de que EasySell inicialice y lea la cookie
  fetch('/discount/NODISCOUNT', { method: 'GET' }).catch(() => {});

  // ─── ACTUALIZADOR DE TOTAL EN TIEMPO REAL ─────────────────────────────────
  function parsePrice(text) {
    const clean = text.trim()
      .replace(/S\/\./g, '')
      .replace(/PEN/g, '')
      .replace(/\s/g, '')
      .trim();
    if (clean.includes(',') && !clean.includes('.')) {
      return parseFloat(clean.replace(',', '.'));
    }
    return parseFloat(clean);
  }

  function getMainProductPrice() {
    const activeVariant = document.querySelector('.louvi-variant-box.active .louvi-variant-price');
    if (activeVariant) {
      const price = parsePrice(activeVariant.textContent);
      if (!isNaN(price)) return price;
    }
    return 0;
  }

  function getUpsellsTotal() {
    let total = 0;
    const checkedBoxes = document.querySelectorAll(
      '.st_single-upsell-checkbox-input:checked, input[class*="st_single-upsell-checkbox"]:checked'
    );
    checkedBoxes.forEach(function (checkbox) {
      const item = checkbox.closest('.st_multi_upsell_item');
      if (!item) return;
      const priceEl = item.querySelector('.st_multi_price');
      if (priceEl) {
        const price = parsePrice(priceEl.textContent);
        if (!isNaN(price)) total += price;
      }
    });
    return total;
  }

  function updateSternifyTotal() {
    const totalEl = document.querySelector('.st_multi_footer_price');
    if (!totalEl) return;

    const mainPrice = getMainProductPrice();
    const upsellsTotal = getUpsellsTotal();
    const grandTotal = mainPrice + upsellsTotal;

    if (grandTotal > 0) {
      totalEl.textContent = grandTotal.toFixed(2).replace('.', ',') + '\u00a0PEN';
    }
  }

  function initTotalUpdater() {
    const container = document.querySelector('#sternify-upsell-content');
    if (!container) return;

    container.addEventListener('change', function (e) {
      if (e.target && (
        e.target.classList.contains('st_single-upsell-checkbox-input') ||
        e.target.className.includes('st_single-upsell-checkbox')
      )) {
        setTimeout(updateSternifyTotal, 50);
      }
    });

    document.querySelectorAll('.louvi-variant-box').forEach(function(box) {
      box.addEventListener('click', function() {
        setTimeout(updateSternifyTotal, 100);
      });
    });

    document.addEventListener('variant:changed', updateSternifyTotal);
    document.addEventListener('variantChange', updateSternifyTotal);

    setTimeout(updateSternifyTotal, 300);
    setTimeout(updateSternifyTotal, 800);
    setTimeout(updateSternifyTotal, 1500);

    const observer = new MutationObserver(function() {
      updateSternifyTotal();
    });
    const sternifyContainer = document.querySelector('#sternify-upsell-content');
    if (sternifyContainer) {
      observer.observe(sternifyContainer, { subtree: true, attributes: true, attributeFilter: ['checked'] });
    }
  }

  function initCodButton() {
    const btn = document.getElementById('louvi-cod-btn');
    const msg = document.getElementById('louvi-cod-msg');

    if (!btn) return;

    btn.addEventListener('click', async function () {
      msg.textContent = '';
      msg.className = '';
      btn.disabled = true;
      btn.querySelector('.louvi-cod-text').textContent = 'Agregando al carrito…';

      try {
        // 0. Cerrar EasySell si está abierto
        const esClose = document.querySelector('.es-close');
        if (esClose) { esClose.click(); await new Promise(r => setTimeout(r, 200)); }

        const items = [];

        // 1. Producto principal
        const productForm =
          document.querySelector('form[action="/cart/add"]') ||
          document.querySelector('#product-form') ||
          document.querySelector('.product-form');

        if (!productForm) throw new Error('No se encontró el formulario del producto.');

        const variantInput = productForm.querySelector('input[name="id"]') || productForm.querySelector('[name="id"]');
        if (!variantInput || !variantInput.value) throw new Error('No se pudo leer la variante del producto.');

        const mainVariantId = parseInt(variantInput.value, 10);
        const qtyInput = productForm.querySelector('input[name="quantity"]');
        const mainQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        items.push({ id: mainVariantId, quantity: mainQty });

        // 2. Upsells de Sternify marcados
        const upsellCheckboxes = document.querySelectorAll(
          '.st_single-upsell-checkbox-input:checked, input[class*="st_single-upsell-checkbox"]:checked'
        );

        upsellCheckboxes.forEach(function (checkbox) {
          let variantId = checkbox.getAttribute('data-variant-id') || '';
          if (variantId.includes('/')) variantId = variantId.split('/').pop();
          variantId = parseInt(variantId, 10);
          if (variantId && !isNaN(variantId)) {
            items.push({ id: variantId, quantity: 1 });
          }
        });

        // 3. Limpiar carrito
        await fetch('/cart/clear.js', { method: 'POST' });
        await new Promise(r => setTimeout(r, 150));

        // 4. Agregar al carrito
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        });

        if (!addResponse.ok) {
          const errorData = await addResponse.json();
          throw new Error(errorData.description || 'Error al agregar al carrito.');
        }

        // 5. Limpiar cualquier descuento de combo previo
        await fetch('/discount/NODISCOUNT', { method: 'GET' }).catch(() => {});
        await new Promise(r => setTimeout(r, 200));

        // 6. Abrir EasySell
        const easysellBtn = document.querySelector('#es-popup-button, #es-sticky, .es-sticky-btn');
        if (easysellBtn) {
          easysellBtn.click();
        } else {
          msg.textContent = '✓ Productos agregados. Haz clic en el botón de pedido para continuar.';
          msg.className = 'success';
        }

      } catch (error) {
        console.error('[LOUVI COD]', error);
        msg.textContent = error.message || 'Ocurrió un error. Inténtalo de nuevo.';
      } finally {
        btn.disabled = false;
        btn.querySelector('.louvi-cod-text').textContent = 'PAGO CONTRA ENTREGA';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCodButton();
      initTotalUpdater();
    });
  } else {
    initCodButton();
    initTotalUpdater();
  }
})();